import { api } from '@/api';
import { throwExternalWindowPopup } from '@/pro/helpers/popup';
import type { AppsAppNoInstalledMalls, NcpXhrError } from 'ncp-api-supporter';

export const TOGGLE_GROUP_SELECT = -2;
export const NOT_GROUP_SELECT = -1;
export const INIT_GROUP_SELECT = 0;

export const excludePath = [
  '/pro/premium/sms/reject/config', // 080 수신거부 관리 페이지
];

export const initFavoriteMenu = () => ({
  name: window.$t('FAVORITE'),
  menus: [],
  order: 0,
  displayable: true,
});


export const executeApp = async (appNo: number, { mallNo, popupInfo, installedDateTime, expireDateTime, paymentType }: AppsAppNoInstalledMalls): Promise<void> => {
  const expiredInAppPurchase =
    paymentType === 'IN_APP_PURCHASE' &&
    expireDateTime &&
    installedDateTime !== expireDateTime &&
    new Date(expireDateTime) < new Date();
  try{
    const {
      data: { code, appUrl },
    } = await api.postWorkspaceAdminAuthTokenServerApiCode({
      data: { appNo: appNo.toString(), mallNo },
    });

    if (expiredInAppPurchase) {
      // 얼럿 호출 후 계속 동작함
      // 권한이 없는 경우는 노출할 필요가 없어서 post 호출 후 성공 시에만 얼럿 노출
      alert('서비스 이용 기간이 만료되었습니다. 앱에서 이용기간을 연장해 주세요.');
    }

    if (!appUrl) {
      alert('실행가능한 앱이 아닙니다.');

      return;
    }

    const url = new URL(appUrl);
    url.searchParams.append('code', code);
    url.searchParams.append('solution', 'shopby');
    const newUrl = url.href;

    if (popupInfo) {
      const x = (window.screenX || window.screenLeft || 0) + (screen.width - popupInfo.width) / 2;
      const y = (window.screenY || window.screenTop || 0) + (screen.height - popupInfo.height) / 2;

      window.open(
        newUrl,
        '_blank',
        `toolbar=no, channelmode=no, location=no, directories=no, menubar=no, resizable=no, top=${y}, left=${x}, width=${popupInfo.width}, height=${popupInfo.height}`,
      );
    } else {
      window.open(newUrl, '_blank');
    }
  }catch(error){
    const { status, data } = error as NcpXhrError;

    if (status === 403) {
      alert('해당 메뉴의 쓰기 권한이 없습니다.');
    } else if (data.code === 'AOP0001') {
      // api 응답으로 결제팝업 url을 message에 넣어서 줌
      const paymentUrl = data.message;
      paymentUrl ? throwExternalWindowPopup(paymentUrl) : alert('정상적으로 처리되지 않았습니다.');
    } else if (data.code === 'AI0002') {
      //AI0002 - 설치된 앱을 찾을 수 없습니다.
      alert(data.message ?? '정상적으로 처리되지 않았습니다.');
    } else if (data.code === 'AI0003') {
      //AI0003 - 앱 설치를 지원하지 않는 몰입니다.
      alert(data.message ?? '정상적으로 처리되지 않았습니다.');
    } else if (data.code === 'AOP0004') {
      //AI0004 - 유료앱 결제 필요
      const queryObject = { redirectUrl: window.location.href };
      const queryString = new URLSearchParams(queryObject).toString();
      const url = `${process.env.VUE_APP_APP_STORE_URL}/subscription/${data.message ?? ''}?${queryString}`;

      throwExternalWindowPopup(url, 'sm');
    } else {
      alert(data.message ?? '정상적으로 처리되지 않았습니다.');
    }
  }

}
